<template>
  <div
      v-loading="loading"
      class="content devices">
    <el-card v-if="locations.length === 0">
      <div
          slot="header"
          class="clearfix">
        <span class="header-item">Locations</span>
      </div>
      <div class="card-content">
        This customer has no locations
      </div>
    </el-card>
    <div v-else>
      <LocationDetails
          v-for="location in locations"
          :key="location.id"
          :data-id="location.location_id"
          :customer="customer"
          :location="location"
          :owner="locationOwner(location.owner_id)"
          :users="locationUsers(location.location_id)"
          :smb-users="location.authorized_users"
          :devices="sortedLocationDevices(location.location_id)"
          :sos="locationSos(location.location_id)" />
      <el-pagination
          background
          style="padding: 25px 0 20px"
          :hide-on-single-page="true"
          :current-page.sync="pagination.currentPage"
          :page-size="pagination.size"
          layout="prev, pager, next"
          :total="pagination.total"
          @current-change="handlePageChange" />
    </div>
  </div>
</template>

<script>
import axios from "axios";
import LocationDetails from "./Location/LocationDetails";
import { createNamespacedHelpers } from "vuex";

const { mapGetters: locationGetters, mapActions: locationActions } =
  createNamespacedHelpers("db/account/location");

export default {
  name: "Location",
  components: { LocationDetails },
  props: {
    customer: {
      type: Object,
      default: () => {},
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      pagination: {
        currentPage: 1,
        size: 5,
        total: 0,
      },
    };
  },
  computed: {
    ...locationGetters([
      "locations",
      "locationDevices",
      "locationUsers",
      "locationOwner",
      "locationSos",
    ]),
    customerExist() {
      return this.customer.id && this.customer.id !== "customer_id_not_found";
    },
  },
  watch: {
    "customer.id": function () {
      this.pagination.currentPage = 1;
      this.pagination.size = 5;
      this.pagination.total = 0;
      this.getLocations();
    },
  },
  created() {
    this.getLocations();
  },
  methods: {
    ...locationActions(["loadLocations", "setLocationAuthorizedUsers"]),
    getLocations() {
      if (!this.customerExist) return;
      this.loading = true;
      this.loadLocations({
        customerId: this.customer.id,
        page: this.pagination.currentPage,
        pageSize: this.pagination.size,
      })
        .then((response) => {
          this.pagination.total = response.total;
          this.loadAuthorizedUsers();
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.scroll();
          this.loading = false;
        });
    },
    sortedLocationDevices(location_id) {
      return this.locationDevices(location_id).sort((a, b) =>
        a.name.localeCompare(b.name)
      );
    },
    scroll() {
      if (this.$route.query.hasOwnProperty("location_id"))
        this.$nextTick(() => {
          this.$scrollTo(`div[data-id='${this.$route.query.location_id}']`, {
            duration: 500,
            container: "#main-content",
          });
        });
    },
    handlePageChange(page) {
      this.pagination.currentPage = page;
      this.getLocations();
    },
    loadAuthorizedUsers() {
      const promises = this.locations.map((location) => {
        if (!location.location_id) return Promise.resolve();
        if (location.authorized_users) return Promise.resolve();

        return axios
          .get(
            `v3/customers/${this.customer.id}/authorized_users?location_id=${location.location_id}`
          )
          .then((response) => {
            // Extract users from the response data structure
            const locationData = response.data.find(
              (item) =>
                item.location &&
                item.location.location_id === location.location_id
            );

            let authorizedUsers = [];
            if (
              locationData &&
              locationData.location &&
              locationData.location.users
            ) {
              authorizedUsers = locationData.location.users;
            }

            // Dispatch an action
            this.setLocationAuthorizedUsers({
              locationId: location.location_id,
              authorizedUsers: authorizedUsers,
            });

            return authorizedUsers;
          })
          .catch((error) => {
            console.error("Error loading authorized users:", error);
            return [];
          });
      });

      // This ensures all promises are resolved before continuing
      return Promise.all(promises);
    },
  },
};
</script>

<style lang="scss">
.devices.content .el-col {
  border-right: solid 1px #ccc;
  min-height: 200px;
  padding-left: 40px !important;
  padding-right: 40px !important;
  &:last-child {
    border-right: none !important;
  }
  .address-row {
    color: #999;
    i {
      color: #000;
    }
  }
  .users-row {
    margin: 1em 0px;
    &:last-child {
      margin: 0px;
    }
    .users-row-label {
      color: #999;
      padding-bottom: 0px;
    }
    .users-row-email {
      color: #599ce7;
      font-weight: bold;
      position: relative;
      &.selected {
        color: #999 !important;
      }
      i {
        color: #000;
      }
    }
  }
}
</style>
